import styled from '@emotion/styled';
import { Accordion } from '@hotjar/hotsauce';
import { useEffect, useState } from 'react';
import type {
  WizardStep,
  WizardSummary,
  WizardSectionKey,
} from '../../../../domain/common/Wizard/Wizard';
import { AccordionSection } from './AccordionSection/AccordionSection';
import { StepFooter } from './AccordionSection/AccordionSectionFooters';

const AccordionWrapper = styled.div<{ isDisabled: boolean }>`
  ${({ isDisabled }) => (isDisabled ? 'opacity:0.7; pointer-events: none;' : '')}
`;

export interface WizardAccordionProps {
  activeSteps: number[];
  onToggleSection?: ({ index, open }: { index: number; open: boolean }) => void;
  onChange: (sectionIndex: number) => void;
  steps: WizardStep<WizardSectionKey>[];
  showSummary: boolean;
  summary: WizardSummary;
  isDisabled: boolean;
}

export const WizardAccordion = ({
  activeSteps,
  onToggleSection,
  onChange,
  steps,
  showSummary,
  summary,
  isDisabled,
}: WizardAccordionProps): JSX.Element | null => {
  const [reset, setReset] = useState(false);
  const stepsSignature = steps.map(({ key }) => key).join('-');

  // TODO: check for a cleaner solution
  // the accordion from Reach UI gets indexes mixed up when the accordion
  // sections change. Re-rendering the accordion fixes it, but it's not ideal
  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  useEffect(() => {
    setReset(true);
  }, [stepsSignature]);

  return reset ? null : (
    <AccordionWrapper isDisabled={isDisabled}>
      <Accordion
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO: fix this type in the hotsauce component
        sectionToShow={activeSteps}
        isWizard
        setUncontrolled
        onToggleSection={onToggleSection}
        onChange={onChange}
        size="s"
        readOnly={isDisabled}
      >
        {steps.map((step, index) => (
          <AccordionSection
            customIndex={index}
            key={step.key}
            section={step}
            footerContent={<StepFooter step={step} />}
          />
        ))}
        {showSummary && <AccordionSection section={summary} />}
      </Accordion>
    </AccordionWrapper>
  );
};
